<a class="btn btn-outline-primary mb-3" routerLink="../credit-collection">Credit collection list</a>
<div class="card mb-3">
    <div class="card-header d-flex flex-row justify-content-between">
        <h2 class="card-title mb-0">Player Credit Report</h2>
    </div>
    <div class="p-3">
        <div class="d-flex flex-row gap-3 align-items-end mb-3 flex-wrap">
            <div>
                <label class="form-label">Date From</label>
                <input type="date" class="form-control" [(ngModel)]="data.start_date" />
            </div>
            <div>
                <label class="form-label">Date To</label>
                <input type="date" class="form-control" [(ngModel)]="data.end_date" />
            </div>
            <div>
                <label class="form-label">Type</label>
                <select class="form-select" [(ngModel)]="data.type">
                    <option value="">All</option>
                    <option value="grant">Grant</option>
                    <option value="collect">Collect</option>
                </select>
            </div>
            <div>
                <label class="form-label">Player Search</label>
                <input type="text" class="form-control" [(ngModel)]="data.player_search"
                    placeholder="Code, Name, or Mobile" />
            </div>
            <button class="btn btn-primary" (click)="filter()">Filter</button>
        </div>
    </div>
</div>

<div class="mb-3 card" *ngIf="!load && items.length > 0">
    <div class="card-body p-3 d-flex flex-row flex-wrap gap-3 align-items-center">
        <div class="card">
            <div class="card-body">
                <p class="mb-0"><b>Total Records:</b> {{summary.total_count}}</p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p class="mb-0"><b>Total Granted:</b> {{summary.total_grant | number:'1.2-2'}}</p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p class="mb-0"><b>Total Collected:</b> {{summary.total_collect | number:'1.2-2'}}</p>
            </div>
        </div>
    </div>
</div>

<div class="card">
    <div class="card-body p-0">

        <ng-container *ngIf="!load && items.length == 0">
            <h3 class="mb-0 px-2 py-3">No Data Available</h3>
        </ng-container>

        <ng-container *ngIf="load">
            <div class="d-flex flex-row align-items-center justify-content-center p-2">
                <div class="loader"></div>
            </div>
        </ng-container>

        <ng-container *ngIf="!load && items.length > 0">
            <table class="table table-sm table-striped mb-0" style="font-size: 12px;">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Date/Time</th>
                        <th>Player Code</th>
                        <th>Player Name</th>
                        <th>Type</th>
                        <th class="text-end">Amount</th>
                        <th class="text-end">Wallet Movement</th>
                        <th class="text-end">Outstanding Before</th>
                        <th class="text-end">Outstanding After</th>
                        <th>Admin</th>
                        <th>Remark</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of items; let i = index;">
                        <td>{{i + 1}}</td>
                        <td>{{item.create_on | date: "dd-MM-yyyy HH:mm:ss"}}</td>
                        <td>{{item.player_code}}</td>
                        <td>{{item.player_name}}</td>
                        <td><span class="badge" [class.bg-primary]="item.type == 'grant'"
                                [class.bg-danger]="item.type == 'collect'">{{item.type}}</span></td>
                        <td class="text-end">{{item.amount | number:'1.2-2'}}</td>
                        <td class="text-end">{{item.wallet_amount | number:'1.2-2'}}</td>
                        <td class="text-end">{{item.outstanding_before | number:'1.2-2'}}</td>
                        <td class="text-end">{{item.outstanding_after | number:'1.2-2'}}</td>
                        <td>{{item.admin}}</td>
                        <td>{{item.remark}}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="5" class="text-end"><b>Grant / Collect Total</b></td>
                        <td class="text-end"><b>{{summary.total_grant | number:'1.2-2'}} /
                                {{summary.total_collect | number:'1.2-2'}}</b></td>
                        <td colspan="5"></td>
                    </tr>
                </tfoot>
            </table>
        </ng-container>
    </div>
</div>
